var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('h4',[_vm._v("Convenciones")]),_vm._l((_vm.tipos),function(tipo){return _c('div',[_c('b-button',{staticClass:"pt-0 pb-0 mt-1 mr-1",attrs:{"title":tipo.nombre,"variant":"success","size":"sm"}},[_vm._v(" "+_vm._s(tipo.nombre_corto)+" ")]),_vm._v(" "+_vm._s(tipo.nombre)+" ")],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }